import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/core/auth/auth.service';
import { eRegicardService } from './services/eregicard.service';
import { User } from 'src/app/core/auth/auth.model';
import { Common } from 'src/app/core/common';
import { FunctionId, Message, MessagePrefix } from 'src/app/core/system.const';
import { eRegicardInfo } from './model/eregicard.model';

@Component({
  selector: 'app-eregicard',
  templateUrl: './eregicard.component.html',
  styleUrls: ['./eregicard.component.scss']
})
export class eRegicardComponent implements OnInit {
  public cond: eRegicardInfo;
  public ImageData:string;

  //for insert,cancel,save button disabled and enabled
  public isInsertDisabled: boolean=false;
  public isCancelDisabled:boolean=true;
  public isSaveDisabled:boolean=false;

  private timer: any;
  private isTimerStop: boolean = true;
  /** timerイベントクリア用変数 */
  private sleep: any;
  constructor(private authService: AuthService
      , private eregicardService: eRegicardService
      , public dialogRef: MatDialogRef<eRegicardComponent>
      , @Inject(MAT_DIALOG_DATA) public data: any) {

    this.ImageData=data.ImageData;
    this.cond=data;
  }

  //#region ---- Event Method ----
    ngOnInit() {

    }


  //call Registration Card Data
   public getRegistrationCardData() {
          this.eregicardService.getRegistrationCard(this.cond).subscribe((res: eRegicardInfo) => {
            let status=res.Status;
              let FailureReason=res.FailureReason;
              let ErrorDescription=res.ErrorDescription;
              if(status=="Success"){
                this.isCancelDisabled=true;
                this.isSaveDisabled=false;
                this.ImageData="data:image/png;base64,"+res.ImageData;
              }
          });
  };


//save eRegistration Card data
  public saveRegicardInfo() {
    this.eregicardService.saveRegicardInfo(this.cond).subscribe((res: eRegicardInfo) => {
        if (res != null)
        {
          let msgTitle: string = res.Status;
          let message: string =  res.ErrorDescription;
          let functid :string = res.FailureReason;
          if(msgTitle == 'Success'){
            this.isInsertDisabled=true;
            this.isCancelDisabled=false;
            this.isTimerStop=false;
            this.timer = setInterval( () => {
              if(!this.isTimerStop){
               this.getRegistrationCardData();
              }
              else{
                clearInterval(this.timer);
              }
              }, 3000 );

          }
          else{
            this.dialogRef.close();
            Common.modalMessageError(msgTitle, message, MessagePrefix.ERROR + functid);
          }
        }

      });
    }


//cancel booking
public cancelBooking() {
  this.isTimerStop=true;
  this.eregicardService.cancelRegicardInfo(this.cond).subscribe((res: eRegicardInfo) => {
    if (res != null)
    {
      let msgTitle:string=res.Status;
      let ErrorDescription:string=res.ErrorDescription;
      let FailureReason:string=res.FailureReason;
      this.dialogRef.close();
      // if(msgTitle='Success'){
      //   Common.modalMessageSuccess(msgTitle,"レジカード","Success");
      // }
      // else{
      //   Common.modalMessageError(msgTitle,FailureReason,ErrorDescription);
      // }
    }
  });
}

//continue checkin process
public continuteCheckin(){
  this.isTimerStop=true;
  this.dialogRef.close('save');
}
//#endregion
}
